import { render, staticRenderFns } from "./TrendWue.vue?vue&type=template&id=211086cb&scoped=true&"
import script from "./TrendWue.vue?vue&type=script&lang=js&"
export * from "./TrendWue.vue?vue&type=script&lang=js&"
import style0 from "./TrendWue.vue?vue&type=style&index=0&id=211086cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211086cb",
  null
  
)

export default component.exports